import React, {Component, useEffect, useState} from "react";
import PropTypes from "prop-types";
import PublicCatalogLayout from "../../layouts/PublicCatalogLayout"
import EventSubheader from "../partials/EventSubheader"
import GenerateEventReportModal from "./GenerateEventReportModal";
import ReportEntry from "./ReportEntry";
import { renderButton } from "@/shared/FormUtils";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const ItemReportsShow = (
  props
)=> {
  const [ loading, setLoading ] = useState(true);
  const [reports, setReports] = useState([]);


  const handleNewReport = (newReport) => {
    reports.push(newReport);
    setReports(reports);
  }

  const handleDeletedReport = (id) => {
    setReports((current) => current.filter((r) => r.id !== id));
  }

  useEffect(() => {
    fetchReports();

    const interval = setInterval(() => {
      fetchReports();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchReports = () => {
    fetch(`/webapi/events/${props.event.id}/reports/items_report_status`)
    .then((res) => res.json())
    .then((json) => {
      setReports(json.reports);
      setLoading(false);
    })
  }

  return (
    <PublicCatalogLayout
      currentPage="events" {...props}
      groups={[]}
      classNames={{container: 'full-width-container'}}
      subHeader={
        <EventSubheader 
          {...props}
        />
      }
    >
      <div className="row" style={{marginTop: "24px"}}>
        <div className="col-xs-6">
          <h1>Item Reports</h1>
          <p>PDF's will generate in the background once you've created a report, come back later or refresh to see if your report is ready to download.</p>
        </div>
        <div className="col-xs-6 event-reports-create-button-container">
          <GenerateEventReportModal button={renderButton("Create Item Report")} handleNewReport={handleNewReport} {...props}/>
        </div>
      </div>
      {loading ? (<div>Loading...</div>) : (
        <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "100%" }}>Report Name</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Created</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reports.length > 0 ? reports.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at);
              }).map(report => (
                <ReportEntry
                  key={report.id || report.name}
                  report={report}
                  event={props.event}
                  onDeleted={handleDeletedReport}
                />
              )) : (
                <TableRow>
                  <TableCell colSpan={3}>There are no reports for this event</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
   
    </PublicCatalogLayout> 
  );
}

export default ItemReportsShow